import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { useQuery } from 'react-query';
import { useAlert } from 'shared/components/alerts';
import { Site } from 'shared/hooks';

export const useGetPreferredWorkerOptions = ({
  site,
  companyId,
  departmentId,
  jobTypeId,
  startDate,
  startTime,
  endDate,
  endTime,
  isTempWork,
  isFreelance,
  certificates,
}: {
  site: Site;
  companyId?: string;
  departmentId?: string;
  jobTypeId?: string;
  startDate?: string;
  startTime?: string;
  endDate?: string;
  endTime?: string;
  isTempWork?: boolean;
  isFreelance?: boolean;
  certificates?: string[];
}) => {
  const { alertError } = useAlert();
  const enabled =
    !!site &&
    !!departmentId &&
    !!jobTypeId &&
    !!startDate &&
    !!endDate &&
    !!startTime &&
    !!endTime &&
    (isTempWork || isFreelance);

  const startDateTime = `${startDate}T${startTime}`;
  const endDateTime = `${endDate}T${endTime}`;

  return useQuery(
    QUERY_KEYS.preferredWorkerOptions(
      companyId,
      departmentId,
      jobTypeId,
      certificates,
      isTempWork,
      isFreelance,
      startDateTime,
      endDateTime
    ),
    async () =>
      await sharedShiftService.getPreferredWorkerOptions(
        site,
        companyId,
        departmentId,
        jobTypeId,
        certificates,
        isTempWork,
        isFreelance,
        startDateTime,
        endDateTime
      ),
    { enabled, onError: (e) => alertError(e) }
  );
};
